import { IsNotEmpty, IsString } from 'class-validator';

export class UnlockSiteUnitModel {
  @IsString()
  @IsNotEmpty()
  siteUnitCode!: string;
}
